import s from '@corratech/pylot-custom-widgets/ShishaCardGroup/ShishCard.module.scss'
import React, { ReactElement } from 'react'
import cn from 'classnames'
import Link from 'next/link'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
}
const ShishaCardGroup = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: {
            heading,
            content,
            subline,
            buttonlink,
            buttontext,
            iscardcontenttop
        },
        children
    } = props
    const enhancedChildren = children?.map((item) => {
        item.props.data.childLength = children?.length
        return item
    })

    return (
        <div className={s['shishaGroupWrapper']}>
            <div className={s.ShishaCardGroup}>
                <span className={s.subline}>{subline}</span>
                <h3 className={s.mainHeading}>{heading}</h3>
                <span className={s.content}>{content}</span>
                <div
                    className={cn(
                        s.ShishaCardGroupChildren,
                        'shishaGroupLength',
                        `shishaGroupLength-${children?.length}`,
                        {
                            iscardcontenttop: iscardcontenttop === 'true'
                        }
                    )}
                >
                    {enhancedChildren}
                </div>
                {buttonlink && buttontext && (
                    <Link href={buttonlink}>
                        <span className={cn('btn-primary')}>{buttontext}</span>
                    </Link>
                )}
            </div>
        </div>
    )
}
export default ShishaCardGroup
